"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var MoreIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 26 6", fill: "currentColor", width: size || '26', height: size || '20' }, props),
        React.createElement("path", { fill: "currentColor", d: "M3 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm10 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm10 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3z", fillRule: "evenodd" })));
};
MoreIcon.displayName = 'MoreIcon';
exports.default = MoreIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MoreIcon.js.map